/**
 * WhyUs — 왜 인증이지인가? (new design)
 *
 * preview/index.html 의 .whyus 1:1 매칭
 *  - 다크 배경 + 2단 그리드 (좌측: 텍스트 + 4개 카드 / 우측: 사진)
 *  - 1023 이하: 1단 (사진 먼저, 텍스트 다음 순서로 자연스럽게)
 *
 * 데이터: WHYUS_CARDS (config/constants.ts)
 */
import { WHYUS_CARDS } from '@/config/constants';

export function WhyUs() {
  return (
    <section className="whyus">
      <div className="whyus-inner">
        <div className="whyus-left">
          <span className="section-tag">WHY CERT EASY</span>
          <h2 className="section-title">
            왜 <span className="accent">인증이지</span>와<br />
            함께해야 하나요?
          </h2>
          <p className="section-sub">
            단순 서류 작성을 넘어, 기업 현황을 분석하고 적합한 인증·지원사업을 함께 찾아드립니다.
          </p>

          <div className="whyus-cards">
            {WHYUS_CARDS.map((card) => (
              <div key={card.title} className="whyus-card">
                <div className="whyus-card-num">
                  {card.num}
                  {card.numUnit && <span className="h">{card.numUnit}</span>}
                </div>
                <div className="whyus-card-title">{card.title}</div>
                <p className="whyus-card-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="whyus-photo">
          <img src="/whyus.webp" alt="인증이지 컨설팅 안내" loading="lazy" />
        </div>
      </div>
    </section>
  );
}
